import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PrimaryButton, SecondaryButton } from 'shared';
import Localize from 'components/Localize';
import {
  cancelPseudonymization,
  logout,
} from 'actions/authActions';
import {
  Actions,
  Countdown,
  Description,
  Screen,
  Title,
} from './PseudonymizationScreenStyled';
import { formatRemainingTime } from './formatRemainingTime';

const localizedText = (id, fallback) => (
  <Localize id={id} options={{ onMissingTranslation: () => fallback }} />
);

const getRemainingSeconds = (deadline) => {
  const deadlineTime = Date.parse(deadline);
  if (Number.isNaN(deadlineTime)) {
    return 0;
  }
  return Math.max(0, Math.ceil((deadlineTime - Date.now()) / 1000));
};

export const PseudonymizationScreen = ({
  cancelPseudonymization,
  cancelling,
  logout,
  process,
}) => {
  const [remainingSeconds, setRemainingSeconds] = useState(
    getRemainingSeconds(process.deadline),
  );

  useEffect(() => {
    const updateCountdown = () => setRemainingSeconds(
      getRemainingSeconds(process.deadline),
    );
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [process.deadline]);

  const rest = formatRemainingTime(remainingSeconds);

  return (
    <Screen data-testid="pseudonymization-screen">
      <Title>{localizedText('pseudonymization-title', 'Profil wird gelöscht')}</Title>
      <Description>
        {localizedText(
          'pseudonymization-description',
          'Ihr Profil wird nach Ablauf der angezeigten Zeit unwiderruflich gelöscht.',
        )}
      </Description>
      <Countdown role="timer" aria-live="polite">
        {rest.value !== null && `${rest.value} `}
        {localizedText(rest.id, rest.fallback)}
      </Countdown>
      <Actions>
        <PrimaryButton
          type="button"
          loading={cancelling}
          onClick={cancelPseudonymization}
        >
          {localizedText('cancel-pseudonymization', 'Löschvorgang abbrechen')}
        </PrimaryButton>
        <SecondaryButton type="button" onClick={logout}>
          {localizedText('logout', 'Abmelden')}
        </SecondaryButton>
      </Actions>
    </Screen>
  );
};

PseudonymizationScreen.propTypes = {
  cancelPseudonymization: PropTypes.func.isRequired,
  cancelling: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired,
  process: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    state: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
    deadline: PropTypes.string.isRequired,
    remaining_seconds: PropTypes.number.isRequired,
  }).isRequired,
};

export const mapStateToProps = ({ pseudonymization: { loading, data } }) => ({
  cancelling: loading,
  process: data.process,
});

export default connect(mapStateToProps, {
  cancelPseudonymization,
  logout,
})(PseudonymizationScreen);
